/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListGroups200ResponseItemsInner } from './ListGroups200ResponseItemsInner';
import {
    ListGroups200ResponseItemsInnerFromJSON,
    ListGroups200ResponseItemsInnerFromJSONTyped,
    ListGroups200ResponseItemsInnerToJSON,
    ListGroups200ResponseItemsInnerToJSONTyped,
} from './ListGroups200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListGroups200Response
 */
export interface ListGroups200Response {
    /**
     * 
     * @type {Array<ListGroups200ResponseItemsInner>}
     * @memberof ListGroups200Response
     */
    items?: Array<ListGroups200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListGroups200Response
     */
    paging?: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListGroups200Response interface.
 */
export function instanceOfListGroups200Response(value: object): value is ListGroups200Response {
    return true;
}

export function ListGroups200ResponseFromJSON(json: any): ListGroups200Response {
    return ListGroups200ResponseFromJSONTyped(json, false);
}

export function ListGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ListGroups200ResponseItemsInnerFromJSON)),
        'paging': json['paging'] == null ? undefined : ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListGroups200ResponseToJSON(json: any): ListGroups200Response {
    return ListGroups200ResponseToJSONTyped(json, false);
}

export function ListGroups200ResponseToJSONTyped(value?: ListGroups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ListGroups200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

